import { Link } from "react-router-dom";

function Features(props) {
  return (
    <>
      <div>
        <i className="fa-solid fa-cube fa-2xl"></i>
        <h3>{props.title}</h3>
        <p>{props.text}</p>
        <article className="FAQ-link">
          <Link to="/FAQ">FAQ </Link>
          <i className="fa-solid fa-chevron-right"></i>
        </article>
      </div>
    </>
  );
}

export default Features;
